import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AppProvider, useApp } from "@/context/AppContext";
import { I18nProvider } from "@/context/i18n";
import { api } from "@/lib/api";
import Home from "@/pages/Home";
import HotelResults from "@/pages/HotelResults";
import HotelDetail from "@/pages/HotelDetail";
import FlightResults from "@/pages/FlightResults";
import ActivityResults from "@/pages/ActivityResults";
import TransferResults from "@/pages/TransferResults";
import Checkout from "@/pages/Checkout";
import Confirmation from "@/pages/Confirmation";
import MyTrips from "@/pages/MyTrips";
import Watchlist from "@/pages/Watchlist";
import RegionPage from "@/pages/RegionPage";
import Admin from "@/pages/Admin";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function AuthCallback() {
  const { setUser } = useApp();
  const hasProcessed = React.useRef(false);
  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sid = new URLSearchParams(window.location.hash.replace("#", "")).get("session_id");
    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id: sid });
        setUser(res.data);
      } catch (e) { console.error("auth failed", e); }
      finally {
        const dest = sessionStorage.getItem("postLoginRedirect") || "/";
        sessionStorage.removeItem("postLoginRedirect");
        window.location.replace(dest);
      }
    })();
  }, [setUser]);
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#1A2E28] text-white">
      <div className="text-center fade-up">
        <div className="w-10 h-10 border-2 border-white/30 border-t-white rounded-full animate-spin mx-auto mb-4" />
        <p className="font-display text-2xl">Vaya Holidays…</p>
      </div>
    </div>
  );
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/results/hotels" element={<HotelResults />} />
      <Route path="/hotels/:code" element={<HotelDetail />} />
      <Route path="/results/flights" element={<FlightResults />} />
      <Route path="/results/activities" element={<ActivityResults />} />
      <Route path="/results/transfers" element={<TransferResults />} />
      <Route path="/checkout" element={<Checkout />} />
      <Route path="/confirmation/:reference" element={<Confirmation />} />
      <Route path="/trips" element={<MyTrips />} />
      <Route path="/watchlist" element={<Watchlist />} />
      <Route path="/region/:slug" element={<RegionPage />} />
      <Route path="/admin" element={<Admin />} />
    </Routes>
  );
}

function App() {
  return (
    <I18nProvider>
      <AppProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AppProvider>
    </I18nProvider>
  );
}

export default App;
